<template>
  <div>
<el-card style=" max-width: 500px; width:100%; height: 50vh;overflow-y: auto ">
  <el-card-section >
          <div class="text-h6">Privacy Policy</div>
          <el-space />
          <el-btn icon="close" flat round dense @click="showModal = false" />
        </el-card-section>

          <el-card-section class="custom-list"  >
        <h5>Important Notice</h5>
        <ol>
          <li>
            We fully recognize the importance of personal information to you. We will strictly collect, use, store, and share (collectively referred to as "process") your personal information in accordance with relevant laws, regulations, and our privacy policy (hereinafter referred to as "this Privacy Policy"). This Privacy Policy applies to the various products and services we provide to you. It is intended to explain how we process your personal information when you use our products or services, and how you can access, update, or delete this information
          </li>
          <li>
            Before using our products or services, please carefully read and fully understand this Privacy Policy. Once you start using our products or services or provide us with your personal information, it means you are aware of and fully agree to the processing of this information by us in accordance with this Privacy Policy.
           </li>
          <li>
            The online platforms through which we provide products or services (including but not limited to databases, official websites, mobile apps) may contain links or directions to other websites. Please note that we do not control these websites, and this Privacy Policy does not apply to these websites under any circumstances. We recommend that you read their privacy policies carefully when accessing these websites.
          </li>
          <li>
            If you have any questions, opinions, or suggestions regarding this Privacy Policy, you may contact us through any of the contact methods listed in Article 9 of this Privacy Policy.
          </li>
        </ol>

        <h5>Definitions</h5>
        <ul>
          <li><strong>You：</strong>refers to individuals who use our products or services, including those who use our products or services under the account of an institutional client.</li>
          <li><strong>We：</strong> refers to the provider of the products or services, Wuxi Autowell Technology Co., Ltd. (also referred to as "Autowell").</li>
          <li><strong>Products or Services：</strong>refers to the database information browsing, query, download, and other services we provide in professional fields such as law, finance, human resources, and healthcare through channels including but not limited to computers and mobile smart terminals.</li>
          <li><strong>Personal Information：</strong>refers to various types of information recorded electronically or by other means that can identify a specific natural person on its own or in combination with other information, or reflect the activities of a specific natural person. This includes but is not limited to name, identification document number, contact information, address, account credentials, financial status, and movement or location data. </li>
        </ul>

        <h5>How We Collect and Use Your Information</h5>
        <p>During your use of our products or services, we will collect your personal information only when absolutely necessary and to a very limited extent. This information is solely used to provide you with products or services, optimize our offerings, and ensure the security of your account. Specifically, we will collect the information you voluntarily provide or the information generated through your use of our products and services in the following ways:</p>
        <ol>
          <li>
            During your use of our products or services, we may also collect information such as the name of your organization, department, position, company size, and industry. This information helps us conduct better marketing research and analysis to provide you with better services. You can choose whether to provide this information, and not providing it will not affect your use of our products and services.
          </li>
          <li>
            We may use your contact information to send you surveys, event invitations, commercial advertisements, and other information. If you do not wish to receive this information, you can unsubscribe at any time by following the instructions in the email or contact us at pr@wxautowell.com to unsubscribe.
          </li>
          <li>
            When you contact us or we proactively seek your suggestions or opinions through surveys or phone calls, we may save your communication/call records and content. These records are used to help us improve our services and respond to user inquiries. Unless required by relevant laws, these records should not be considered confidential.
          </li>
          <li>
            When you use our products or services, certain information about you, including but not limited to the model of the device you use, unique identifier, operating system, browser type, display resolution, internet protocol address, domain name, web pages, time and duration of website access, and pages visited during service usage, may be collected (i.e., collected without you actively providing this information) through internet protocol addresses, cookies, URL tags, and navigation data collection methods, and recorded in server log files. We may use this information for data statistical analysis to improve our services and marketing. 
          </li>
          <li>
            Our website uses internet protocol (IP) address technology. The IP address is a number assigned by the internet service provider to your computer to enable you to access the internet. In most cases, the IP address is dynamic (changing each time you connect to the internet) rather than static (permanently associated with a user's computer), and thus is typically not considered personal identification information. We use your IP address to diagnose server problems, report information, determine the fastest connection path between your computer and the site, and manage and improve the website.
          </li>
          <li>
            A "cookie" is a small amount of information sent by a website to your browser to help the site remember information about you and your preferences.@wxautowell.com。
          </li>
          <li>
            "Session cookies" are temporary pieces of information that are automatically deleted when you exit your browser window or shut down your computer. Session cookies are used to improve website navigation and collect statistical data.
          </li>
          <li>
            "Persistent cookies" are pieces of information that remain stored on your computer's hard drive indefinitely unless deleted. These cookies serve various purposes, such as retrieving previously submitted information (e.g., passwords), helping identify the most valuable areas for website visitors, and customizing the website based on your preferences. The primary purpose of using cookies on our website is to store your default preferences.
          </li>
          <li>
            You can set your browser to notify you immediately when cookies are received so you can decide whether to accept them.
          </li>
          <li>
            You can also set your browser to completely block cookies, but please note that this may hinder your use of our website or services. For more information about cookies, please visit www.cookiecentral.com/faq.
          </li>
          <li>
             Currently, we do not actively collect any information other than what is expressly stated in this Privacy Policy, including obtaining your personal information from third parties. If we need to collect such personal information in the future for business development, we will obtain your explicit consent before collecting such information. If we collect your personal information from third parties, we will require the third party to ensure the legality of the information provided.
          </li>
          <li>
            We will only use your information in accordance with the legal requirements and for the purposes specified in this Privacy Policy. If we need to use your personal information for purposes beyond the aforementioned, we will seek your consent again.
          </li>
         
        </ol>

        <h5>How We Protect and Retain Your Information</h5>
        <p> Measures to Protect Your Personal Information</p>
        <ol>
          <li>
            We take the protection of personal information very seriously and adopt security technologies and measures that comply with industry standards to safeguard the personal information you provide.
          </li>
          <li>
            We implement specific management systems, processes, and organizational measures to ensure information security. For example, we use a centralized customer information management system, and access to this system is restricted to employees who need it for their work. Only authorized personnel are allowed to query and manage customer information, and the system is only installed on designated office devices. We strictly define access permissions for customer information and require all employees who may handle your personal information to comply with confidentiality obligations. Additionally, we periodically train employees on relevant laws, regulations, and privacy security guidelines to strengthen security awareness.
          </li>
          <li>
            In the event of a personal information breach or security incident, we will activate an emergency response plan to contain the incident and notify you through push notifications, announcements, or other appropriate means.
          </li>
          <li>
            The internet environment is not 100% secure, and we will do our best to ensure the security of any information you send to us. If our physical, technical, or managerial protection measures are compromised, leading to unauthorized access, disclosure, alteration, or destruction of your information, and thereby causing damage to your legal rights, we will be liable according to the law.
          </li>
        </ol>

        <h5>Retaining Your Information</h5>
        <ol>
          <li>
            Storage Location: Personal information collected and generated within the People’s Republic of China will be stored within the country.
          </li>
          <li>
            Storage Period: In general, we will retain your personal information only for the time necessary to achieve the purposes outlined in this privacy policy, unless longer retention is required or permitted by law.
          </li>
        </ol>

        <h5>How We Share Information</h5>
        <ol>
          <li>
            We may share your information with our affiliates or partners. For data statistical analysis purposes, Autowell may aggregate your usage information of our products or services without identifying your personal identity. Additionally, our customer information management and order management systems may be managed and maintained by third-party service providers ("Suppliers"), who may have access to your information. We will sign strict data protection agreements with these suppliers, requiring them to handle your personal information in accordance with the law, this privacy policy, and other relevant confidentiality requirements, maintaining security standards that are at least equivalent to our own.
          </li>
          <li>
            Except for disclosures required by applicable laws, court orders, or government regulations, we will not disclose your personal information to any third party without your consent.
          </li>
          <li>
            As our business continues to develop, we may undergo mergers, acquisitions, or asset transfers. In such cases, we will notify you of the relevant situation and continue to protect or ensure the new controllers maintain the protection of your personal information in accordance with legal requirements and at least to the standards required by this privacy policy.
          </li>
        </ol>

        <h5>How to Manage Your Personal Information</h5>
        <ol>
          <li>
            You can log in to your account on our website to view your personal information, order and transaction details, browsing history, and other information you have submitted to us.
          </li>
          <li>
            To ensure correct identity verification, please update your information promptly to keep it accurate, up-to-date, and complete. If you encounter any issues during this process, please feel free to contact us.
          </li>
          <li>
            After you cancel your account or it expires, if you submit a request, we will delete or anonymize your personal information according to your wishes and in compliance with legal requirements.
          </li>
        </ol>

        <h5>Privacy Protection for Minors</h5>
        <ol>
          <li>
            If you are a minor, we recommend that you have your parents or guardians carefully read this privacy policy and only use our services or provide information to us with their consent.
          </li>
          <li>
             For the collection of personal information of minors with parental or guardian consent, we will only use, share, or disclose such information in accordance with the law, with explicit consent from the parents or guardians, or when necessary to protect the minor.
          </li>
        </ol>

        <h5>Revisions to the Privacy Policy and Notifications</h5>
        <p>
          Due to changes in service content, contact information, legal and regulatory requirements, we may revise this Privacy Policy from time to time. When changes occur, we will publish the updated version on our official website, mobile platform, or send it to the email address you provided. To ensure you receive timely notifications, we recommend updating your account information or informing us when your email address changes.
        </p>

        <h5>Contact Us</h5>
        <p>If you need to contact us regarding any issues mentioned in this privacy policy, you can reach us at:</p>
        <ul>
          <li>Phone: +86-0510-81816658</li>
          <li>Email: pr@wxautowell.com</li>
        </ul>
      </el-card-section>
</el-card>
  </div>
</template>

<script>

export default {
  name: "CustomerInfoForm2",
  data() {
    return {
      formData: {
        name: "",
        gender: "",
        company: "",
        departmentPosition: "",
        email: "",
        phone: "",
        productOfInterest: ""
      },
      editflag: false,
      status: "submit",
      submittedData: null,
      genderOptions: ["男 (Male)", "女 (Female)", "其他 (Other)"],
      isPrivacyChecked: false,
      showModal: false,
      url: "http://192.168.100.16:16000",
      rules: {
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        company: [{ required: true, message: "请输入您的公司名称", trigger: "blur" }],
        departmentPosition: [
          { required: true, message: "请输入您的部门和职位", trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入有效的邮箱", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }
        ],
        productOfInterest: [
          { required: true, message: "请输入您感兴趣的产品", trigger: "blur" }
        ]
      }
    };
  },
 
};
</script>

<style scoped>
.custom-list  {
  text-align: left;
}
</style>